import React from "react";

const LabelText = ({ text }) => (
    <span style={{ marginTop: "5px", marginBottom: "2px" }}>
        {text}
    </span>
);

export default LabelText;
